import { buildProps, definePropType } from '@zoryn/utils'
import { panelSharedProps } from './shared'

import type { ExtractPropTypes, ExtractPublicPropTypes } from 'vue'
import type { DayOrDays } from '@zoryn/components/time-picker'

export const panelDatePickProps = buildProps({
  ...panelSharedProps,
  parsedValue: {
    type: definePropType<DayOrDays>([Object, Array]),
  },
  visible: {
    type: Boolean,
    default: true,
  },
  format: {
    type: String,
    default: '',
  },
} as const)

export type PanelDatePickProps = ExtractPropTypes<typeof panelDatePickProps>
export type PanelDatePickPropsPublic = ExtractPublicPropTypes<
  typeof panelDatePickProps
>
